import { FormEvent, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { login } from '../../api/auth';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { PasswordInput } from '../../components/PasswordInput';
import { AuthSplitLayout } from '../../components/AuthSplitLayout';
import { useAuth } from '../../context/AuthContext';

export function Login() {
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [manterConectado, setManterConectado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const { setUsuario } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEnviando(true);

    try {
      const { usuario } = await login(identificador, senha, manterConectado);
      setUsuario(usuario);
      Swal.fire({ icon: 'success', title: `Bem-vindo, ${usuario.nome}!`, timer: 1200, showConfirmButton: false });
      navigate('/painel');
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Não foi possível entrar',
        text: error.response?.data?.erro || 'Confira seus dados e tente novamente.',
        confirmButtonColor: '#1845ba',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthSplitLayout titulo="Entrar" subtitulo="Acesse seu painel.">
      <form onSubmit={handleSubmit} className="lizzi-auth-form">
        <Input
          label="E-mail ou celular"
          value={identificador}
          onChange={(e) => setIdentificador(e.target.value)}
          required
          placeholder="Digite seu acesso"
        />

        <PasswordInput
          label="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
          placeholder="Digite sua senha"
        />

        <div className="lizzi-auth-inline-row">
          <Form.Check
            type="checkbox"
            id="manter-conectado"
            label="Manter conectado"
            checked={manterConectado}
            onChange={(e) => setManterConectado(e.target.checked)}
          />
          <Link to="/esqueci-senha">Esqueci minha senha</Link>
        </div>

        <Button type="submit" disabled={enviando}>
          {enviando ? 'Entrando...' : 'Entrar'}
        </Button>
      </form>

      <div className="lizzi-auth-bottom-copy">
        <span>Ainda não tem conta?</span>
        <Link to="/cadastro">Criar cadastro</Link>
      </div>
    </AuthSplitLayout>
  );
}
